export function getJsonLDScript (taxonomy: Object) {
  return {
    type: 'application/ld+json',
    children: JSON.stringify({
      '@context': 'https://schema.org',
      ...taxonomy,
    }),
  }
}
